<div class="dashboard-container" id="dashboard-top">
  <div class="view-navigation-bar">
    <button mat-button class="nav-tab-btn" [class.tab-active]="activeView === 'search'" (click)="switchView('search')">
      <mat-icon>search</mat-icon>
      物件検索
    </button>
    <button mat-button class="nav-tab-btn" [class.tab-active]="activeView === 'saved'" (click)="switchView('saved')">
      <mat-icon>assignment_turned_in</mat-icon>
      保存済み物件
    </button>
  </div>

  <div *ngIf="activeView === 'search'">
    <div class="page-header">
      <h2 class="title">条件を指定して物件を検索</h2>
    </div>

    <div class="progress-widget" *ngIf="extractionProgress">
      <div class="widget-header" style="display: flex; justify-content: space-between; align-items: center;">
        <div style="display: flex; align-items: center; gap: 16px;">
          <h3 class="status-title" style="margin: 0;">
            <span class="spinner" *ngIf="!extractionProgress.is_completed"></span>
            {{ extractionProgress.status_message }}
          </h3>
          <span class="percentage" *ngIf="extractionProgress.total_count > 0">{{ extractionProgress.progress_percentage }}%</span>
          <span class="percentage" *ngIf="extractionProgress.total_count === 0 && !extractionProgress.is_completed">取得中...</span>
        </div>
        <button *ngIf="isProcessing" mat-stroked-button color="warn" (click)="onCancelExtraction()" type="button">
          <mat-icon>stop</mat-icon> 停止
        </button>
      </div>
      
      <div class="progress-track">
        <div 
          class="progress-fill" 
          [style.width.%]="extractionProgress.total_count > 0 ? extractionProgress.progress_percentage : 100"
          [ngClass]="{
            'completed': extractionProgress.is_completed,
            'indeterminate': !extractionProgress.is_completed && extractionProgress.total_count === 0
          }">
        </div>
      </div>

      <div class="details-grid">
        <div class="detail-item">
          <span class="label">処理済み</span>
          <span class="value">{{ extractionProgress.processed_count }} 件</span>
        </div>
        <div class="detail-item">
          <span class="label">詳細取得済</span>
          <span class="value" style="color: #0f5132;">{{ extractionProgress.passed_count || 0 }} 件</span>
        </div>
        <div class="detail-item">
          <span class="label">スキップ</span>
          <span class="value">{{ extractionProgress.skipped_count }} 件</span>
        </div>
        <div class="detail-item">
          <span class="label">取得総数</span>
          <span class="value">{{ extractionProgress.total_count }} 件</span>
        </div>
        <div class="detail-item">
          <span class="label">経過時間</span>
          <span class="value">{{ extractionProgress.elapsed_time }}</span>
        </div>
        <div class="detail-item error-item" *ngIf="extractionProgress.error_count > 0">
          <span class="label">エラー</span>
          <span class="value text-danger">{{ extractionProgress.error_count }} 件</span>
        </div>
      </div>

      <div class="log-section mt-3">
        <div class="log-header">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">list_alt</mat-icon>
          実行ログ
        </div>
        <div class="log-scroll-container" id="log-scroll-container">
          <div *ngFor="let log of processLogs" class="log-entry" [ngClass]="'log-' + log.type">
            <span class="log-time">[{{ log.timestamp | date:'HH:mm:ss' }}]</span>
            <span class="log-text">{{ log.message }}</span>
          </div>
          <div *ngIf="processLogs.length === 0" class="log-empty text-muted">
            <small>待機中...</small>
          </div>
        </div>
      </div>
    </div>

    <form [formGroup]="searchForm">
      
      <mat-card class="setting-card shadow-sm">
        <mat-card-header class="header-inline-layout">
          <mat-card-title class="section-title">
            1次検索条件
          </mat-card-title>
          
          <div class="condition-select-container">
            <mat-form-field appearance="outline" class="condition-select-field">
              <mat-label>保存した条件を読み込む</mat-label>
              <mat-select [(value)]="selectedConditionId" (selectionChange)="onLoadCondition($event.value)">
                <mat-option [value]="null">-- クリア --</mat-option>
                <mat-option *ngFor="let cond of savedConditions" [value]="cond.id">
                  {{ cond.condition_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
            <button mat-stroked-button color="warn" class="delete-cond-btn" 
              *ngIf="selectedConditionId" (click)="onDeleteCondition()" type="button" [disabled]="isProcessing">
              削除
            </button>
          </div>
        </mat-card-header>
        
        <mat-card-content class="vertical-layout-area">
          <div class="vertical-row">
            <div class="field-label-row">
              <span class="field-label">抽出対象サイト</span>
              <mat-checkbox color="primary" [checked]="isAllSelected('sites', ['suumo','homes','rehouse','livable','stepon','nomu'])" 
                (change)="toggleAll('sites', ['suumo','homes','rehouse','livable','stepon','nomu'], $event.checked)" [disabled]="isProcessing">
                すべて選択
              </mat-checkbox>
            </div>
            <div class="checkbox-grid-dense">
              <mat-checkbox *ngFor="let site of targetSites"
                [checked]="searchForm.get('sites')?.value.includes(site.id)"
                (change)="toggleArrayItem('sites', site.id, $event.checked)" [disabled]="isProcessing">
                {{site.name}}
              </mat-checkbox>
            </div>
          </div>

          <mat-divider class="row-divider"></mat-divider>

          <div class="vertical-row">
            <div class="field-label">物件種別</div>
            <mat-radio-group formControlName="propertyType" class="radio-group-horizontal" [disabled]="isProcessing">
              <mat-radio-button value="land">土地</mat-radio-button>
              <mat-radio-button value="house">戸建て</mat-radio-button>
              <mat-radio-button value="all" color="primary">すべて</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-divider class="row-divider"></mat-divider>

          <div class="vertical-row">
            <div class="field-label">エリア指定（東京）</div>
            
            <div class="area-group">
              <div class="area-header">
                <span class="area-title">23区</span>
                <mat-checkbox [checked]="isAll23WardsSelected()" (change)="toggleAll23Wards($event.checked)" color="primary" [disabled]="isProcessing">
                  23区をすべて選択
                </mat-checkbox>
              </div>
              <div class="checkbox-grid-dense">
                <mat-checkbox *ngFor="let ward of tokyo23Wards"
                  [checked]="searchForm.get('selectedAreas')?.value.includes(ward)"
                  (change)="toggleArrayItem('selectedAreas', ward, $event.checked)" [disabled]="isProcessing">
                  {{ward}}
                </mat-checkbox>
              </div>
            </div>

            <div class="area-group mt-2">
              <div class="area-header">
                <span class="area-title">市部</span>
              </div>
              <div class="checkbox-grid-dense">
                <mat-checkbox *ngFor="let city of tokyoCities"
                  [checked]="searchForm.get('selectedAreas')?.value.includes(city)"
                  (change)="toggleArrayItem('selectedAreas', city, $event.checked)" [disabled]="isProcessing">
                  {{city}}
                </mat-checkbox>
              </div>
            </div>
          </div>

          <mat-divider class="row-divider"></mat-divider>

          <div class="vertical-row">
            <div class="field-label">価格帯 (万円)</div>
            <div class="range-inputs">
              <mat-form-field appearance="outline" class="range-field">
                <input matInput type="text" formControlName="minPrice" placeholder="下限">
                <span matSuffix>万円</span>
              </mat-form-field>
              <span class="range-sep">〜</span>
              <mat-form-field appearance="outline" class="range-field">
                <input matInput type="text" formControlName="maxPrice" placeholder="上限">
                <span matSuffix>万円</span>
              </mat-form-field>
            </div>
          </div>

          <mat-divider class="row-divider"></mat-divider>

          <div class="vertical-row">
            <div class="field-label">土地面積 (㎡)</div>
            <div class="range-inputs">
              <mat-form-field appearance="outline" class="range-field">
                <input matInput type="text" formControlName="minArea" placeholder="下限">
                <span matSuffix>㎡</span>
              </mat-form-field>
              <span class="range-sep">〜</span>
              <mat-form-field appearance="outline" class="range-field">
                <input matInput type="text" formControlName="maxArea" placeholder="上限">
                <span matSuffix>㎡</span>
              </mat-form-field>
            </div>
          </div>

          <mat-divider class="row-divider"></mat-divider>

          <div class="vertical-row">
            <div class="field-label">駅徒歩・バス条件</div>
            <div class="inline-inputs">
              <mat-form-field appearance="outline" class="short-field">
                <input matInput type="text" formControlName="maxWalkMinutes" placeholder="指定なし">
                <span matSuffix>分以内</span>
              </mat-form-field>
              <mat-checkbox formControlName="excludeBus" color="warn" class="ml-3">バス便を除外</mat-checkbox>
            </div>
          </div>

          <mat-divider class="row-divider"></mat-divider>

          <div class="vertical-row">
            <div class="field-label">現況（土地の場合）</div>
            <mat-radio-group formControlName="existingBuildingType" class="radio-group-horizontal" [disabled]="isProcessing">
              <mat-radio-button value="vacant">更地・上物なし優先</mat-radio-button>
              <mat-radio-button value="existing">古家あり優先</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-divider class="row-divider"></mat-divider>

          <div class="vertical-row">
            <div class="field-label">最大抽出件数</div>
            <mat-form-field appearance="outline" class="short-field">
              <input matInput type="number" formControlName="maxExtractionCount" placeholder="指定なし">
              <span matSuffix>件まで</span>
            </mat-form-field>
            <div class="mt-1">
              <small class="text-muted" style="color: #6c757d;">※空欄の場合は全件抽出します。</small>
            </div>
          </div>

        </mat-card-content>
      </mat-card>

      <div class="submit-section">
        <button *ngIf="!selectedConditionId" mat-stroked-button color="accent" class="secondary-btn" (click)="onSaveConditions()" type="button" [disabled]="isProcessing">
          条件を保存
        </button>
        
        <ng-container *ngIf="selectedConditionId">
          <button mat-flat-button color="accent" class="secondary-btn" (click)="onUpdateCondition()" type="button" [disabled]="isProcessing">
            上書き保存
          </button>
          <button mat-stroked-button color="primary" class="secondary-btn" (click)="onSaveConditions()" type="button" [disabled]="isProcessing">
            別名で保存
          </button>
        </ng-container>
        
        <ng-container *ngIf="!isProcessing">
          <button mat-flat-button color="warn" class="large-btn" (click)="onSearch()" [disabled]="searchForm.invalid" type="button">
            検索・抽出を実行
          </button>
        </ng-container>
      </div>

    </form>

    <mat-card class="setting-card shadow-sm mt-3" id="analysis-list-section" *ngIf="displayAnalysis">
      <mat-card-header class="header-inline-layout">
        <mat-card-title class="section-title">抽出結果・事業判定</mat-card-title>
      </mat-card-header>
      <mat-card-content class="vertical-layout-area">
        
        <div class="vertical-row" style="background: #f8fafc; padding: 16px; border-radius: 8px; border: 1px solid #e2e8f0; margin-bottom: 16px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
            <div class="field-label" style="margin-bottom: 0;">2次スクリーニング（絞り込み）</div>
            <button mat-stroked-button type="button" (click)="resetSecondaryFilters()" style="height: 28px; line-height: 26px; font-size: 12px;">
              条件リセット
            </button>
          </div>
          <div class="inline-inputs" style="gap: 16px; flex-wrap: wrap;">
            <mat-form-field appearance="outline" class="short-field" style="width: 140px;">
              <mat-label>坪単価（万円以下）</mat-label>
              <input matInput type="number" [(ngModel)]="secondaryFilters.maxTsuboPrice" (ngModelChange)="applySecondaryFilters()" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
            <mat-form-field appearance="outline" class="short-field" style="width: 140px;">
              <mat-label>建蔽率（%以上）</mat-label>
              <input matInput type="number" [(ngModel)]="secondaryFilters.minCoverage" (ngModelChange)="applySecondaryFilters()" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
            <mat-form-field appearance="outline" class="short-field" style="width: 140px;">
              <mat-label>容積率（%以上）</mat-label>
              <input matInput type="number" [(ngModel)]="secondaryFilters.minFar" (ngModelChange)="applySecondaryFilters()" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
            <mat-form-field appearance="outline" class="short-field" style="width: 140px;">
              <mat-label>接道間口（m以上）</mat-label>
              <input matInput type="number" [(ngModel)]="secondaryFilters.minFrontage" (ngModelChange)="applySecondaryFilters()" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
            <mat-form-field appearance="outline" style="width: 250px;">
              <mat-label>用途地域</mat-label>
              <mat-select multiple [(ngModel)]="secondaryFilters.allowedZonings" (ngModelChange)="applySecondaryFilters()" [ngModelOptions]="{standalone: true}">
                <mat-option *ngFor="let zone of zoningOptions" [value]="zone">{{zone}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div style="display: flex; gap: 16px; align-items: center; width: 100%; padding-left: 4px;">
              <mat-checkbox [(ngModel)]="secondaryFilters.ownershipOnly" (ngModelChange)="applySecondaryFilters()" [ngModelOptions]="{standalone: true}" color="primary">所有権のみ</mat-checkbox>
              <mat-checkbox [(ngModel)]="secondaryFilters.noBuildingCondition" (ngModelChange)="applySecondaryFilters()" [ngModelOptions]="{standalone: true}" color="primary">建築条件なし</mat-checkbox>
              <mat-checkbox [(ngModel)]="secondaryFilters.excludeHeightDistrict1" (ngModelChange)="applySecondaryFilters()" [ngModelOptions]="{standalone: true}" color="primary">第1種高度地区を除外</mat-checkbox>
            </div>
          </div>
        </div>
        
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
          <span style="font-weight: bold; color: #4a5568;">該当件数: {{filteredExtractedProperties.length}}件 (選択中: {{selectedPropertyIds.size}}件)</span>
          <button mat-flat-button color="primary" [disabled]="selectedPropertyIds.size === 0" (click)="executeAnalysis()" type="button">事業判定に進める</button>
        </div>

        <div class="property-table-wrapper">
          <table class="analysis-property-table">
            <thead>
              <tr>
                <th style="width: 50px;">
                  <mat-checkbox color="primary" 
                    [checked]="isAllPropertiesSelected()" 
                    [indeterminate]="selectedPropertyIds.size > 0 && !isAllPropertiesSelected()"
                    (change)="selectAllProperties($event.checked)">
                  </mat-checkbox>
                </th>
                <th>物件情報・2次スペック</th>
                <th>判定</th>
                <th>構造・ボリューム</th>
                <th>収支シミュレーション</th>
                <th>判定理由</th>
                <th>アクション</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let result of filteredExtractedProperties" [class.negative-profit-row]="analyzedPropertyIds.has(result.id) && result.is_negative_profit">
                <td>
                  <mat-checkbox color="primary" 
                    [checked]="selectedPropertyIds.has(result.id)"
                    (change)="toggleSelection(result.id)">
                  </mat-checkbox>
                </td>
                <td class="prop-name-cell">
                  <a *ngIf="result.target_url" [href]="result.target_url" target="_blank" style="text-decoration: none; color: inherit;">
                    <strong>{{ result.property_name || '名称不明' }}</strong>
                  </a>
                  <strong *ngIf="!result.target_url">{{ result.property_name || '名称不明' }}</strong>
                  <div class="sub-location-text">{{ result.location || '-' }} <span *ngIf="result.station">({{ result.station }})</span></div>
                  
                  <div class="sub-info-text" style="color: #4a5568; font-weight: 500; margin-top: 4px;">
                    徒歩{{ result.walk_minutes || '-' }}分 / 
                    <ng-container *ngIf="result.min_price_man_yen !== null && result.min_price_man_yen !== undefined; else legacySubPrice">
                      <ng-container *ngIf="result.max_price_man_yen && result.min_price_man_yen !== result.max_price_man_yen; else singleSubPrice">
                        {{ result.min_price_man_yen }}〜{{ result.max_price_man_yen }}万円
                      </ng-container>
                      <ng-template #singleSubPrice>
                        {{ result.min_price_man_yen }}万円
                      </ng-template>
                    </ng-container>
                    <ng-template #legacySubPrice>
                      {{ result.price_man_yen ? result.price_man_yen + '万円' : '-' }}
                    </ng-template>
                    / {{ result.area_sqm || '-' }}㎡
                    <span *ngIf="result.calculated_tsubo_price" style="color: #2b6cb0; font-weight: 600;">
                      (坪単価: {{ result.calculated_tsubo_price }}万円)
                    </span>
                  </div>

                  <div class="sub-info-text" style="display: flex; flex-wrap: wrap; gap: 6px; margin-top: 6px;">
                    <span style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      用途: {{ result.zoning || '不明' }}
                    </span>
                    <span style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      建{{ result.coverage_ratio || '-' }}% / 容{{ result.far || '-' }}%
                    </span>
                    <span *ngIf="result.disp_frontage" style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      間口: {{ result.disp_frontage }}m
                    </span>
                    <span *ngIf="result.disp_right_type" style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      権利: {{ result.disp_right_type }}
                    </span>
                    <span *ngIf="result.disp_building_condition" style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      条件: {{ result.disp_building_condition }}
                    </span>
                    <span *ngIf="result.disp_height_district" style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      {{ result.disp_height_district }}
                    </span>
                  </div>
                </td>
                
                <ng-container *ngIf="analyzedPropertyIds.has(result.id); else unanalyzedCells">
                  <td>
                    <span class="status-badge" [ngClass]="{
                      'badge-possible': result.analysis_status === '事業化可能',
                      'badge-negotiate': isNegotiableStatus(result.analysis_status),
                      'badge-critical-exclude': result.analysis_status === '完全見送り' || result.analysis_status === '見送り(赤字)',
                      'badge-exclude': result.analysis_status === '見送り(条件未達)'
                    }">
                      {{ result.analysis_status || '未判定' }}
                    </span>
                  </td>
                  <td>{{ result.structure_and_volume || '-' }}</td>
                  <td class="whitespace-pre-line">{{ result.income_simulation || '-' }}</td>
                  <td class="whitespace-pre-line">{{ result.analysis_reason || '-' }}</td>
                </ng-container>
                <ng-template #unanalyzedCells>
                  <td colspan="4" class="text-center-empty">未判定</td>
                </ng-template>

                <td>
                  <ng-container *ngIf="analyzedPropertyIds.has(result.id); else unanalyzedAction">
                    <div class="action-btn-area" *ngIf="isSavableStatus(result.analysis_status)">
                      <button mat-stroked-button class="inline-save-btn" [class.btn-saved-status]="result.is_saved === 1" [disabled]="result.is_saved === 1" (click)="onSaveProperty(result)" type="button">
                        {{ result.is_saved === 1 ? '保存済' : '保存' }}
                      </button>
                    </div>
                    <span *ngIf="!isSavableStatus(result.analysis_status)">-</span>
                  </ng-container>
                  <ng-template #unanalyzedAction>
                    <div class="text-center-empty" style="padding: 0;">-</div>
                  </ng-template>
                </td>
              </tr>
              <tr *ngIf="filteredExtractedProperties.length === 0">
                <td colspan="7" class="text-center-empty">該当する物件がありません</td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>

  </div>

  <div *ngIf="activeView === 'saved'">
    <div class="page-header">
      <h2 class="title">保存済み物件一覧</h2>
    </div>

    <mat-card class="setting-card shadow-sm">
      <mat-card-header class="header-inline-layout">
        <mat-card-title class="section-title">お気に入り</mat-card-title>
      </mat-card-header>
      <mat-card-content class="vertical-layout-area">
        <div class="property-table-wrapper">
          <table class="analysis-property-table">
            <thead>
              <tr>
                <th>物件情報・2次スペック</th>
                <th>判定</th>
                <th>構造・ボリューム</th>
                <th>収支シミュレーション</th>
                <th>判定理由</th>
                <th>アクション</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of savedProperties" [class.negative-profit-row]="item.is_negative_profit">
                <td class="prop-name-cell">
                  <a *ngIf="item.target_url" [href]="item.target_url" target="_blank" style="text-decoration: none; color: inherit;">
                    <strong>{{ item.property_name || '名称不明' }}</strong>
                  </a>
                  <strong *ngIf="!item.target_url">{{ item.property_name || '名称不明' }}</strong>
                  <div class="sub-location-text">{{ item.location || '-' }} <span *ngIf="item.station">({{ item.station }})</span></div>
                  
                  <div class="sub-info-text" style="color: #4a5568; font-weight: 500; margin-top: 4px;">
                    徒歩{{ item.walk_minutes || '-' }}分 / 
                    <ng-container *ngIf="item.min_price_man_yen !== null && item.min_price_man_yen !== undefined; else legacySavedPrice">
                      <ng-container *ngIf="item.max_price_man_yen && item.min_price_man_yen !== item.max_price_man_yen; else singleSavedPrice">
                        {{ item.min_price_man_yen }}〜{{ item.max_price_man_yen }}万円
                      </ng-container>
                      <ng-template #singleSavedPrice>
                        {{ item.min_price_man_yen }}万円
                      </ng-template>
                    </ng-container>
                    <ng-template #legacySavedPrice>
                      {{ item.price_man_yen ? item.price_man_yen + '万円' : '-' }}
                    </ng-template>
                    / {{ item.area_sqm || '-' }}㎡
                    <span *ngIf="item.calculated_tsubo_price" style="color: #2b6cb0; font-weight: 600;">
                      (坪単価: {{ item.calculated_tsubo_price }}万円)
                    </span>
                  </div>

                  <div class="sub-info-text" style="display: flex; flex-wrap: wrap; gap: 6px; margin-top: 6px;">
                    <span style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      用途: {{ item.zoning || '不明' }}
                    </span>
                    <span style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      建{{ item.coverage_ratio || '-' }}% / 容{{ item.far || '-' }}%
                    </span>
                    <span *ngIf="item.disp_frontage" style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      間口: {{ item.disp_frontage }}m
                    </span>
                    <span *ngIf="item.disp_right_type" style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      権利: {{ item.disp_right_type }}
                    </span>
                    <span *ngIf="item.disp_building_condition" style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      条件: {{ item.disp_building_condition }}
                    </span>
                    <span *ngIf="item.disp_height_district" style="background: #edf2f7; color: #2d3748; padding: 2px 6px; border-radius: 4px;">
                      {{ item.disp_height_district }}
                    </span>
                  </div>
                </td>
                <td>
                  <span class="status-badge" [ngClass]="{
                    'badge-possible': item.analysis_status === '事業化可能',
                    'badge-negotiate': isNegotiableStatus(item.analysis_status),
                    'badge-critical-exclude': item.analysis_status === '完全見送り' || item.analysis_status === '見送り(赤字)',
                    'badge-exclude': item.analysis_status === '見送り(条件未達)'
                  }">
                    {{ item.analysis_status || '未判定' }}
                  </span>
                </td>
                <td>{{ item.structure_and_volume || '-' }}</td>
                <td class="whitespace-pre-line">{{ item.income_simulation || '-' }}</td>
                <td class="whitespace-pre-line">{{ item.analysis_reason || '-' }}</td>
                <td>
                  <button mat-stroked-button color="warn" class="inline-delete-btn" (click)="onDeleteSavedProperty(item.id)" type="button">
                    削除
                  </button>
                </td>
              </tr>
              <tr *ngIf="savedProperties.length === 0">
                <td colspan="6" class="text-center-empty">保存された物件はありません</td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>